import { get, isEmpty } from 'lodash';
import { BUTTONS, PluginSettingsIcon } from 'wix-rich-content-plugin-commons';
import { getModalStyles } from 'wix-rich-content-editor-common';
import { Modals } from '../modals.js';
import { IMAGE_TYPE } from '../types.js';
import ImageEditorIcon from '../icons/ImageEditorIcon.js';
import MediaReplaceIcon from '../icons/MediaReplaceIcon.js';
import './image-settings.js';
import 'react';
import 'prop-types';
import 'classnames';
import 'wix-rich-content-common';
import 'wix-rich-content-common/libs/imageUtils';
import 'wix-rich-content-ui-components';
import '../style-inject.es-746bb8ed.js';
import '../consts.js';
import 'ricos-schema';
import '../imageStudio/image-editor.js';
import '../imageStudio/image-editor-logic.js';
import '../imageStudio/image-studio-opener-loader.js';

const createInlineButtons = ({
  t,
  anchorTarget,
  relValue,
  uiSettings,
  isMobile,
  settings = {},
  experiments = {}
}) => {
  const icons = get(settings, "toolbar.icons", {});
  const modalStyles = getModalStyles({ isMobile });
  const imageEditorStyles = getModalStyles({
    customStyles: { content: { maxWidth: "100%", background: "transparent" } }
  });
  const { imageEditorWixSettings, onImageEditorOpen } = settings;
  const imageEditorButton = {
    keyName: "imageEditor",
    type: BUTTONS.EXTERNAL_MODAL,
    icon: icons.imageEditor || ImageEditorIcon,
    modalName: Modals.IMAGE_EDITOR,
    modalStyles: imageEditorStyles,
    t,
    imageEditorWixSettings,
    onImageEditorOpen,
    mobile: false,
    tooltipTextKey: "ImageEditorButton_Tooltip",
    mapComponentDataToButtonProps: (componentData) => ({
      disabled: isEmpty(componentData.src) || !!componentData.error
    })
  };
  const { spoilerInInlineToolbar } = experiments;
  const spoilerButton = settings.spoiler && (spoilerInInlineToolbar == null ? void 0 : spoilerInInlineToolbar.enabled) ? [
    {
      keyName: "spoiler",
      type: BUTTONS.SPOILER,
      mobile: true
    }
  ] : [];
  const replaceButton = {
    keyName: "replace",
    type: BUTTONS.FILES,
    onFilesSelected: (pubsub, files) => {
      if (files.length > 0) {
        pubsub.getBlockHandler("handleFilesSelected")(files);
      }
    },
    icon: icons.replace || MediaReplaceIcon,
    mobile: true,
    tooltipTextKey: "ReplaceImageButton_Tooltip",
    t
  };
  return [
    { keyName: "sizeOriginal", type: BUTTONS.SIZE_ORIGINAL, mobile: false },
    { keyName: "sizeSmallCenter", type: BUTTONS.SIZE_SMALL_CENTER, mobile: false },
    { keyName: "sizeContent", type: BUTTONS.SIZE_CONTENT, mobile: false },
    { keyName: "sizeFullWidth", type: BUTTONS.SIZE_FULL_WIDTH, mobile: false },
    { keyName: "separator1", type: BUTTONS.SEPARATOR, mobile: false },
    { keyName: "alignLeft", type: BUTTONS.SIZE_SMALL_LEFT, mobile: false },
    { keyName: "alignCenter", type: BUTTONS.SIZE_CONTENT_CENTER, mobile: false },
    { keyName: "alignRight", type: BUTTONS.SIZE_SMALL_RIGHT, mobile: false },
    { keyName: "separator2", type: BUTTONS.SEPARATOR, mobile: false },
    ...spoilerButton,
    ...imageEditorWixSettings ? [imageEditorButton] : [],
    {
      keyName: "settings",
      type: BUTTONS.EXTERNAL_MODAL,
      fullHeight: true,
      icon: icons.settings || PluginSettingsIcon,
      modalName: Modals.IMAGE_SETTINGS,
      modalStyles,
      anchorTarget,
      relValue,
      t,
      mobile: true,
      tooltipTextKey: "SettingsButton_Tooltip",
      uiSettings,
      triggerSettingsBi: true,
      pluginId: IMAGE_TYPE,
      shouldShowSpoiler: settings.spoiler
    },
    { keyName: "link", type: BUTTONS.LINK, mobile: true },
    replaceButton,
    { keyName: "delete", type: BUTTONS.DELETE, mobile: true }
  ];
};

export { createInlineButtons as default };
//# sourceMappingURL=inline-buttons.js.map
